import React, { useState, useEffect } from 'react';
import { Calendar, Clock, Plus } from 'lucide-react';
import Card  from '@/components/ui/Card';
import Button  from '../../ui/Button';
import ApiService from '../../../services/api';

const Appointments = () => {
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAppointments();
  }, []);

  const fetchAppointments = async () => {
    try {
      const data = await ApiService.getAppointments();
      setAppointments(data);
    } catch (error) {
      console.error('Error fetching appointments:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold">Appointments</h2>
        <Button>
          <Plus className="w-4 h-4 mr-2" />
          New Appointment
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Upcoming Appointments */}
        <Card className="p-6">
          <h3 className="text-lg font-semibold mb-4">Upcoming Appointments</h3>
          <div className="space-y-4">
            {appointments.map((apt) => (
              <div
                key={apt.id}
                className="flex items-center p-4 border rounded-lg hover:bg-gray-50"
              >
                <div className="mr-4">
                  <Calendar className="w-10 h-10 text-primary-600" />
                </div>
                <div>
                  <h4 className="font-medium">{apt.customerName}</h4>
                  <p className="text-sm text-gray-600">
                    {new Date(apt.date).toLocaleString()}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </Card>

        {/* Calendar View */}
        <Card className="p-6">
          <h3 className="text-lg font-semibold mb-4">Calendar</h3>
          {/* Add calendar component here */}
        </Card>
      </div>

      {/* Recent Appointments */}
      <Card className="p-6">
        <h3 className="text-lg font-semibold mb-4">Recent Appointments</h3>
        <table className="w-full">
          <thead>
            <tr className="text-left border-b">
              <th className="pb-2">Customer</th>
              <th className="pb-2">Date</th>
              <th className="pb-2">Status</th>
              <th className="pb-2">Actions</th>
            </tr>
          </thead>
          <tbody>
            {appointments.map((apt) => (
              <tr key={apt.id} className="border-b">
                <td className="py-4">{apt.customerName}</td>
                <td className="py-4">
                  {new Date(apt.date).toLocaleString()}
                </td>
                <td className="py-4">
                  <span className={`px-2 py-1 rounded-full text-sm ${
                    apt.status === 'completed' 
                      ? 'bg-green-100 text-green-800'
                      : 'bg-yellow-100 text-yellow-800'
                  }`}>
                    {apt.status}
                  </span>
                </td>
                <td className="py-4">
                  <Button variant="ghost" size="sm">
                    View
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
};

export default Appointments;